import { Icon } from "@/assets/icons";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../Button";
import notfoundImg from "@/assets/page_not_found3.svg"

const Screen404: React.FC = () => {
  return (
    <div className="flex flex-col items-center gap-2 lg:h-[100vh] justify-center">
      <img src={notfoundImg} alt="404page" />
      <div className="text-cyan text-3xl-plus font-bold">404 Not Found</div>
      <div className="text-cyan text-lg leading-160% font-bold">
        お探しのページは見つかりませんでした
      </div>
      <div className="text-light_secondary leading-160% font-noto-sans">
        <div>申し訳ありませんが、お探しのページは存在しません。</div>
        <div>
          移動または削除された可能性があるか、URLが間違っている可能性があります。
        </div>
      </div>
      <Link to="/">
        <Button
          type="button"
          variant="solid"
          color="primary"
          iconLeft={<Icon name="home" />}
          className="!h-12"
        >
          トップページへ
        </Button>
      </Link>
    </div>
  );
};

export { Screen404 };
